import React from "react";

import Typography from "@/components/ui/typography";

const LoadingSpinner = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-background">
    <div className="p-8 flex flex-col items-center gap-4">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      <Typography size="b2" className="text-muted-foreground">
        Loading...
      </Typography>
    </div>
  </div>
);

export default LoadingSpinner;
